import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// The kit's text styles, radii and shadow are custom `atlas-*` theme keys that
// tailwind-merge does not know. Without registering them it cannot tell that
// `text-atlas-label` (a text style) and `text-atlas-dark` (a colour) set different
// properties, and would drop one of them; nor that a later `rounded-atlas-full`
// overrides a base `rounded-atlas-md`. Registering them makes each property merge
// correctly, last one wins.
const TEXT_STYLES = [
	'atlas-h1',
	'atlas-h2',
	'atlas-h3',
	'atlas-supporting',
	'atlas-body',
	'atlas-body-medium',
	'atlas-body-semibold',
	'atlas-label',
	'atlas-label-medium',
	'atlas-label-bold',
	'atlas-label-semibold',
	'atlas-caption-medium',
	'atlas-avatar',
	'atlas-avatar-sm',
	'atlas-title-small',
	'atlas-tab',
	'atlas-search-table',
	'atlas-link-value',
	'atlas-link-action',
	'atlas-dp-label',
	'atlas-menu-item',
	'atlas-wordmark',
	'atlas-comment-author',
	'atlas-comment-meta',
	'atlas-comment-body',
	'atlas-comment-placeholder',
	'atlas-avatar-comment',
	'atlas-toast-action',
]

const twMerge = extendTailwindMerge({
	extend: {
		classGroups: {
			'font-size': [{ text: TEXT_STYLES }],
			rounded: [
				{
					rounded: ['atlas-sm', 'atlas-badge', 'atlas-md', 'atlas-lg', 'atlas-full', 'atlas-menu-item', 'atlas-action'],
				},
			],
			shadow: [{ shadow: ['atlas-drop-2'] }],
		},
	},
})

/**
 * Merge class names, resolving conflicting Tailwind utilities so the last one wins.
 * The class-composition helper every UI Kit component uses.
 */
export function cn(...inputs: ClassValue[]): string {
	return twMerge(clsx(inputs))
}
